module.exports = "/assets/data/7612b682e28d60f527f7e6efaa772a17-BD16.data.json";